// 收藏存储在浏览器 localStorage（免登录）。
// 存整份卡片数据的快照，收藏页无需再请求后端即可展示；同时记录收藏数（本地）。
const KEY = 'paperdigest-favorites';

export function getFavorites() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function isFavorited(id) {
  return getFavorites().some((f) => f.id === id);
}

export function addFavorite(paper) {
  const list = getFavorites().filter((f) => f.id !== paper.id);
  list.unshift({ ...paper, _fav_at: Date.now() });
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event('favorites-changed'));
}

export function removeFavorite(id) {
  const list = getFavorites().filter((f) => f.id !== id);
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event('favorites-changed'));
}

export function toggleFavorite(paper) {
  if (isFavorited(paper.id)) removeFavorite(paper.id);
  else addFavorite(paper);
}

// 本地收藏计数：全站聚合无后端，这里用本机是否收藏 + 基础值。
// 返回该论文的展示收藏数（本机收藏则 +1，否则用 paper 自带 fav_count 或 0）。
export function displayFavCount(paper, favorited) {
  const base = paper.fav_count || 0;
  return favorited ? base + 1 : base;
}
